import Avatar2 from "../../assets/images/lg/avatar2.jpg";
import Avatar9 from "../../assets/images/lg/avatar9.jpg";

function TopPerformers({ data }) {

    return (
        <div className="card light-danger-bg">
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Top Performers</h6>
            </div>
            <div className="card-body">
                <div className="row g-3 align-items-center">
                    <div className="col-md-12 col-lg-4 col-xl-4 col-xxl-2">
                        <p>You have {data?.taskStats?.totalEmployees} <span className="fw-bold">influencers </span> in your company.</p>
                        <div className="d-flex  justify-content-between text-center">
                            <div className="">
                                <h3 className="fw-bold">{data?.taskStats?.totalTasks}</h3>
                                <span className="small">Total Task</span>
                            </div>
                            <div className="">
                                <h3 className="fw-bold">{data?.taskStats?.completedTasks}</h3>
                                <span className="small">Task Completed</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-12 col-xl-12 col-xxl-10">
                        <div className="row g-3 row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-3 row-cols-xl-3 row-cols-xxl-6 row-deck top-perfomer">
                            {data?.topPerformance?.map((val, index) => (
                                <div key={index} className="col">
                                    <div className="card shadow">
                                        <div className="card-body text-center d-flex flex-column justify-content-center">
                                            <img className="avatar lg rounded-circle img-thumbnail mx-auto" src={val?.employeeImage ? val?.employeeImage : val?.employeeGender === "Men" ? Avatar9 : Avatar2} crossOrigin="anonymous" alt="profile" />
                                            <h6 className="fw-bold my-2 small-14">{val?.employeeName}</h6>
                                            <span className="text-muted mb-2">{val?.completed}/{val?.total}</span>
                                            <h4 className="fw-bold text-primary fs-3">{Number(val?.performance)}%</h4>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default TopPerformers;